<template>
  <div class="news article container section">
    <div class="columns">
      <div class="column body tw-my-5">
        <skeleton-loading v-if="isLoading" />
        <template v-else-if="blog">
          <blog-content :blog="blog">
            <template v-slot:comment>
              <div class="section-block tw-mt-5">
                <span class="title">COMMENTS & DISCUSSIONS</span>
              </div>
              <comment v-if="blog" :model="blog" />
            </template>
          </blog-content>
        </template>
      </div>
      <div class="column is-one-third">
        <div class="section-block tw-justify-between">
          <span class="title tw-mb-0">MORE BLOGS</span>
          <router-link
            :to="{ name: 'training' }"
            class="tw-flex tw-items-center tw-uppercase tw-text-base tw-self-center has-text-primary"
          >
            <span class="tw-font-semibold">View more</span>
            <b-icon icon="chevron-right" size="is-medium"></b-icon>
          </router-link>
        </div>
        <skeleton-loading class="tw-mb-6" v-if="isLoadingRecentBlogs" />
        <template v-else>
          <blog-card
            class="tw-mb-6"
            v-for="recent in recentBlogs.data"
            :key="recent.id"
            :blog="recent"
            redirect-to="training.blogs.view"
            small
          />
        </template>
        <div>
          <p class="tw-mb-2 tw-text-gray-300">Follow us on social media</p>
          <a target="_blank" href="https://facebook.com/mustardschools">
            <b-icon class="tw-text-gray-200 tw-mr-4" icon="facebook-box" />
          </a>
          <a target="_blank" href="https://instagram.com/mustardschools">
            <b-icon class="tw-text-gray-200" icon="instagram"></b-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '@/services/env'
import Blog from '@/models/Blog'
import * as BlogType from '@/utils/consts/BlogType'
import BlogContent from '@/components/BlogContent'
import BlogCard from '@/components/BlogCard'
import Comment from '@/components/comment'

export default {
  components: {
    BlogContent,
    BlogCard,
    Comment
  },
  metaInfo() {
    if (this.blog) {
      return {
        title: this.blog.title
      }
    }
  },
  data() {
    return {
      env,
      isLoading: false,
      isLoadingRecentBlogs: false,
      recentBlogs: {
        data: [],
        meta: {}
      },
      blog: null
    }
  },
  mounted() {
    this.getBlog(this.$route.params.slug)
    this.getRecentBlogs()
  },
  methods: {
    getBlog(slug) {
      this.isLoading = true
      Blog.include('created_by', 'cover')
        .where('type', BlogType.TRAINING)
        .$find(slug)
        .then(blog => {
          this.blog = blog
        })
        .catch(() => {
          this.$router.replace({ name: 'news' })
        })
        .then(() => {
          this.isLoading = false
        })
    },
    getRecentBlogs() {
      this.isLoadingRecentBlogs = true
      Blog.include('created_by', 'cover')
        .where('type', BlogType.TRAINING)
        .limit(5)
        .get()
        .then(response => {
          this.recentBlogs = response
        })
        .catch(() => {})
        .then(() => {
          this.isLoadingRecentBlogs = false
        })
    }
  },
  watch: {
    $route() {
      this.getBlog(this.$route.params.slug)
    }
  }
}
</script>
